import { dateFormatter } from "../../BuyerProfile";

export const columns = (setViewOrEdit, setShowAddModal, setSelectedRate, tableParams, deleteHandler) => {
  return [
    {
      title: "S.NO",
      dataIndex: "id",
      sorter: true,
      width: "5%",
      render: (text, record, index) =>
        tableParams.current ? index + 1 + (tableParams.current - 1) * tableParams.pageSize : index + 1,
    },
    {
      title: "Comment",
      dataIndex: "comment",
      width: "20%",
    },
    {
      title: "Rate Creator",
      dataIndex: "ratecreator",
      width: "20%",
    },
    {
      title: "Rated Profile",
      dataIndex: "ratedprofile",
      width: "20%",
    },
    {
      title: "Created At",
      dataIndex: "createdat",
      width: "20%",
      render: (text) => dateFormatter(text),
    },
    {
      title: "ACTIONS",
      dataIndex: "active",
      render: (text, record) => {
        return (
          <div class="d-flex action-button">
            <button
              className="btn btn-info btn-xs light px-2.5 me-2"
              onClick={() => {
                setSelectedRate(record);
                setViewOrEdit("view");
                setShowAddModal(true);
              }}
            >
              <i className="fa fa-eye fs-4"></i>
            </button>
            <button
              className="btn btn-info btn-xs light px-2"
              onClick={() => {
                setSelectedRate(record);
                setViewOrEdit("edit");
                setShowAddModal(true);
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17 3C17.2626 2.73735 17.5744 2.52901 17.9176 2.38687C18.2608 2.24473 18.6286 2.17157 19 2.17157C19.3714 2.17157 19.7392 2.24473 20.0824 2.38687C20.4256 2.52901 20.7374 2.73735 21 3C21.2626 3.26264 21.471 3.57444 21.6131 3.9176C21.7553 4.26077 21.8284 4.62856 21.8284 5C21.8284 5.37143 21.7553 5.73923 21.6131 6.08239C21.471 6.42555 21.2626 6.73735 21 7L7.5 20.5L2 22L3.5 16.5L17 3Z"
                  stroke="#fff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
            <button
              class="ms-2 btn btn-xs px-2 light btn-danger"
              style={{ marginRight: "8px" }}
              onClick={() => {
                deleteHandler(record.id);
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3 6H5H21"
                  stroke="#fff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
                  stroke="#fff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
          </div>
        );
      },
      width: "20%",
    },
  ];
};
